import { BellDot } from 'lucide-react'
import { ViewSearchInput } from '../../../components/view-search-input'
import { View } from '../../../components/view'
import { ViewFilterMenu, type ViewFilterOption } from '../../../components/view-filter-menu'
import { ReminderInput } from '../../../components/reminders/reminders-input'
import type { RemindersViewModel } from '../use-reminders-view-model'
import { REMINDER_FILTERS, REMINDER_FILTER_LABEL, type ReminderFilterType } from '../reminders-view-order'

/**
 * Fixed view header per the Reminders design (`7652:22504`): title lockup with
 * the filter chip, the search pill, then the jot input as the section's CTA
 * row — no tab bar.
 */
export function RemindersViewHeader({ model }: { model: RemindersViewModel }) {
  const options: Array<ViewFilterOption<ReminderFilterType>> = REMINDER_FILTERS.map((value) => ({
    value,
    label: REMINDER_FILTER_LABEL[value],
    count: model.counts[value],
  }))

  return (
    <View.Header
      icon={<BellDot />}
      title="Reminders"
      accessory={
        <ViewFilterMenu value={model.filter} options={options} subject="reminders" onChange={model.setFilter} />
      }
    >
      <ViewSearchInput
        value={model.searchQuery}
        onChange={model.setSearchQuery}
        // "your all reminders" doesn't parse — All's placeholder drops the
        // adjective rather than reading the label like the narrower tabs do.
        placeholder={
          model.filter === 'all'
            ? 'Search your reminders…'
            : `Search your ${REMINDER_FILTER_LABEL[model.filter].toLowerCase()} reminders…`
        }
        label="Search reminders"
      />

      {model.filter !== 'resolved' && <ReminderInput onSubmit={model.addItem} />}
    </View.Header>
  )
}
